var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"offline-timer-scramble"},[_c('h2',{staticStyle:{"display":"inline-block"}},[_vm._v(" "+_vm._s(_vm.$store.state.scramble)+" ")]),_c('v-btn',{attrs:{"text":""},on:{"click":_vm.generateScramble}},[_vm._v(" next ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }